import { InventoryList } from '@repo/ui/components/containers/inventory/list/inventory-list';
import { DashboardLayout } from '@repo/ui/components/dashboard-layout';

export default function InventoryListPage() {
  return (
    <DashboardLayout>
      <div className="">
        <InventoryList />
      </div>
    </DashboardLayout>
  );
}